import SuccinctLayout from '@/layouts/SuccinctLayout';
import NavigationLayout from '@/layouts/NavigationLayout';

export default [
  {
    path: '/navigations',
    component: NavigationLayout,
    children: [
      {
        path: '',
        name: 'navigations',
        component: () => import('@/pages/navigation'),
        meta: { title: '导航' }
      }
    ]
  },
  {
    path: '/projects',
    component: SuccinctLayout,
    children: [
      {
        path: '',
        name: 'projects',
        component: () => import('@/pages/project'),
        meta: { title: '工程中心' }
      }
    ]
  },
  {
    path: '/about',
    component: SuccinctLayout,
    children: [
      {
        path: '',
        name: 'changelog',
        component: () => import('@/pages/about/changelog'),
        meta: { title: '关于我们' }
      }
    ]
  },
  {
    path: '/debug',
    component: SuccinctLayout,
    children: [
      {
        path: '',
        name: 'debug',
        component: () => import('@/pages/about/debug'),
        meta: { title: '调试页面' }
      }
    ]
  },
  {
    path: '/track',
    name: 'analytics',
    component: () => import('@/pages/system/track/index.vue')
  },
  {
    path: '/feedback',
    component: SuccinctLayout,
    children: [
      {
        path: '',
        name: 'feedback',
        component: () => import('@/pages/feedback/feedback'),
        meta: { title: '用户反馈' }
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/login'),
    meta: { title: '登录' }
  },
  {
    path: '/exception',
    name: 'exception',
    component: SuccinctLayout,
    children: [
      {
        path: '404',
        name: '404',
        component: () => import('@/pages/exception/404'),
        meta: { title: '404' }
      },
      {
        path: '403',
        name: '403',
        component: () => import('@/pages/exception/403'),
        meta: { title: '403' }
      },
      {
        path: '500',
        name: '500',
        component: () => import('@/pages/exception/500'),
        meta: { title: '500' }
      }
    ]
  }
];
